import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { waLink } from "../data/business";
import { EASE } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const StoneCard = ({ lot, index }) => {
  const isMelee = lot.type === "melee";
  const text = `Hello Padmavati Gem & Jewelss, I'm interested in lot ${lot.id}: ${lot.shape} ${lot.clarity} ${lot.color}, ${isMelee ? `sieve ${lot.sieve} (${lot.mm})` : `${lot.carat_per_piece} ct (${lot.mm})`}. Please share availability and a quote.`;
  const q = new URLSearchParams({ lot: lot.id, shape: lot.shape, clarity: lot.clarity, carat: lot.carat_range, ...(lot.sieve ? { sieve: lot.sieve } : {}) }).toString();

  return (
    <motion.article
      data-testid={`stone-card-${lot.id}`}
      initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: EASE, delay: Math.min(index * 0.04, 0.4) }}
      className="group relative bg-[#101010] border border-gold/15 hover:border-saffron/60 transition-[border-color,transform] duration-500 hover:-translate-y-1 p-5 flex flex-col"
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-[10px] uppercase tracking-[0.3em] text-gold/80">{lot.id} · {lot.growth}</p>
          <h3 className="font-display text-2xl text-ivory mt-1 leading-none">{lot.shape}</h3>
        </div>
        <span className="text-[10px] uppercase tracking-[0.2em] px-2 py-1 border border-gold/30 text-saffron whitespace-nowrap">{lot.clarity} · {lot.color}</span>
      </div>

      <dl className="mt-5 grid grid-cols-2 gap-x-4 gap-y-3 text-sm">
        <div><dt className="label">Size</dt><dd className="text-ivory/90">{isMelee ? `${lot.sieve} · ${lot.mm}` : lot.mm}</dd></div>
        <div><dt className="label">{isMelee ? "Approx ct / pc" : "Carat"}</dt><dd className="text-ivory/90">{lot.carat_per_piece} ct{isMelee && <span className="text-ivory/40"> · ~{lot.pieces_per_carat}/ct</span>}</dd></div>
        <div><dt className="label">Available</dt><dd className="text-ivory/90" data-testid={`stone-available-${lot.id}`}>~{lot.available_carats} ct</dd></div>
        <div><dt className="label">Growth</dt><dd className="text-ivory/90">{lot.growth}</dd></div>
      </dl>
      <p className="mt-3 text-[11px] text-ivory/45">{lot.certification}</p>

      <div className="mt-5 pt-4 border-t border-gold/10 flex items-center justify-between gap-2">
        <a href={waLink(text)} target="_blank" rel="noreferrer" data-testid={`stone-whatsapp-${lot.id}`} aria-label="Enquire on WhatsApp" className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.2em] text-saffron hover:text-ivory transition-colors">
          <WhatsAppIcon size={18} className="text-[#25D366]" />
        </a>
        <Link to={`/enquiry?${q}`} data-testid={`stone-enquire-${lot.id}`} className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.2em] text-ivory/60 hover:text-saffron transition-colors">
          Enquire <ArrowUpRight size={14} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </motion.article>
  );
};
